import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

export type ImportItemFromFusionRequestBody = {
  partUuid: string;
  hubId: string;
  projectId: string;
  itemId: string;
};

export type ImportItemFromFusionResponse = {
  taskUuid: string;
};

/**
 *
 * Mutation function for importing part files from ADSK Fusion. Returns a task ID
 * that can be used to track the status of the import.
 */
export const useImportItemFromFusion: MutationFunction<
  ImportItemFromFusionResponse,
  ImportItemFromFusionRequestBody
> = ({ requestOptions, queryOptions } = {}) => {
  const urlPath = '/integrations/fusion/import';
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (body) => {
      return request(urlPath, {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    ...queryOptions,
    mutationKey: ['importItemFromFusion'],
  });
};
